import React, { useRef } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import AddLiaisonOfficer from "../../pages/AddLiaisonOfficer/AddLiaisonOfficer";
import SettingsStore from "../../store/SettingsStore";

const CheckLiasionOfficer2 = () => {
  const navigate = useNavigate();
  const settingsHydrated = SettingsStore.isHydrated;
  const userRef = useRef();
  const checkLiaisonOfficer = () => {
    if (SettingsStore.liaisonOfficerData) {
      navigate("/settings/edit-family-office-team", {
        state: { from: "liaison_office_access" },
      });
    }
  };

  userRef.current = checkLiaisonOfficer;

  useEffect(() => {
    if (SettingsStore.isHydrated) {
      userRef.current();
    }
  }, [settingsHydrated]);
  return (
    <div>
      <AddLiaisonOfficer />
    </div>
  );
};

export default CheckLiasionOfficer2;
